export default "__VITE_ASSET__pTrSs2iy__"